import { SUBSCRIPTION_STATUS } from 'components/utils/enums';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { authActions } from '../../redux/slice/auth.slice';
import { useEffect } from 'react';
import { GET_USER_ACCESS, VALIDATE_ACCESS_TOKEN } from '../../redux/types/auth.types';
import Layout from './Layout';
import AppLoader from 'components/shared/AppLoader';
import { accessActions } from '../../redux/slice/access.slice';

const PrivateSubscriptionRoutes = () => {
    const dispatch = useDispatch();
    const auth = useSelector(authActions.selectors.getLoggedInStatus);
    const subscriptionStatus = useSelector(authActions.selectors.getSubscriptionStatus);
    const isAuthLoaded = useSelector(accessActions.selectors.getIsAuthLoaded);

    useEffect(() => {
        dispatch({ type: VALIDATE_ACCESS_TOKEN });
        dispatch({ type: GET_USER_ACCESS });
    }, [dispatch]);


    if (!isAuthLoaded) {
        return <AppLoader />;
    }

    return (
        auth
            ? (subscriptionStatus !== SUBSCRIPTION_STATUS.active
                ? <Layout showSideBar={false}><Outlet /></Layout>
                : <Navigate to='/' />)
            : <Navigate to='/login' />

    );
};

export default PrivateSubscriptionRoutes;
